import React from 'react';
import{useLocation, Link} from 'react-router-dom';

function Error() {
    useLocation();

    return (
        <div className="" style={{display:'flex',justifyContent:'center',alignItems:'center',height:'100vh'}}>
        <h3>
         <span className="fa fa-exclamation-triangle" style={{color:'black'}}/>&nbsp;Page Not Found. Redirect to <Link to='/'>Dashboard</Link>

        </h3>
      </div>
    );
  }

  export default Error;
